var WEBPACK_PREFIX = 'REACT_APP_';
var VITE_PREFIX = 'VITE_';
var createWebpackProvider = function () { return ({
    type: 'webpack',
    getEnv: function (key) { return process.env[WEBPACK_PREFIX + key]; },
}); };
var createViteProvider = function () { return ({
    type: 'vite',
    getEnv: function (key) {
        try {
            return __VITE_ENV__[VITE_PREFIX + key];
        }
        catch (e) {
            throw new Error("Vite environment variable ".concat(key, " not accessible"));
        }
    },
}); };
var envProvider;
var setEnvProvider = function (providerType) {
    if (providerType === 'webpack') {
        envProvider = createWebpackProvider();
    }
    else if (providerType === 'vite') {
        envProvider = createViteProvider();
    }
    else {
        console.warn("setEnvProvider: Invalid provider specified: ".concat(providerType));
    }
};
function getEnvVar(key) {
    if (typeof key !== 'string') {
        console.warn('getEnvVar: Key must be a string');
        return undefined;
    }
    if (!envProvider) {
        var webpackValue = process.env[WEBPACK_PREFIX + key];
        return webpackValue !== undefined ? webpackValue : undefined;
    }
    try {
        var value = envProvider.getEnv(key);
        return value !== undefined ? value : undefined;
    }
    catch (error) {
        console.error("Error retrieving environment variable ".concat(key, ":"), error);
        return undefined;
    }
}

export { getEnvVar, setEnvProvider };
